import { useAuthorize } from "graphql/user";
import { TourStep } from "providers/DashboardTourProvider";
import { useI18n } from "providers/I18nProvider";
import { PermissionEnum } from "types/graphql/graphql";

export const useEmployeesTourSteps = (companyId: string) => {
  const { t } = useI18n();
  const steps: TourStep[] = [];

  const canManageEmployees = useAuthorize(
    PermissionEnum.UpdateEmployee,
    companyId,
  );

  if (canManageEmployees) {
    steps.push({
      title: t(
        "apps.admin.pages.companies.companyId.employees.page.tour.manageEmployees.title",
      ),
      description: t(
        "apps.admin.pages.companies.companyId.employees.page.tour.manageEmployees.description",
      ),
      selector: ".manage-employees-tour-step",
    });
  }

  return {
    steps,
  };
};
